import { useEffect } from "react";
import { useElementSize } from "../../../hooks/index.js";
import { ellipseText } from "../utils/ellipseText.js";
function useMiddleEllipsis(rTarget, mode, ellipsis) {
  const { width, resizing } = useElementSize(rTarget.current);
  useEffect(() => {
    width;
    const target = rTarget.current;
    if (!target) return;
    if (mode === "updateAfterResizing" && resizing) return;
    const firstChild = target.children[0];
    const targetToEllipse = target.querySelector(".ellipseMe") ?? firstChild;
    if (!targetToEllipse) return;
    if (targetToEllipse.hasAttribute("data-original")) {
      targetToEllipse.textContent = targetToEllipse.getAttribute("data-original");
    }
    const parentElement = target.parentElement;
    const targetWidth = parentElement && target.offsetWidth > parentElement.offsetWidth ? parentElement.offsetWidth : target.offsetWidth;
    ellipseText(targetWidth, firstChild, targetToEllipse, ellipsis);
  }, [rTarget, mode, ellipsis, width, resizing]);
}
export {
  useMiddleEllipsis
};
//# sourceMappingURL=useMiddleEllipsis.js.map
